/**
 * Uses the above constant to convert back-end data into format front-end can use for errors
 *
 * @method fieldErrorsBacktoFront
 * @param {Array} backEndErrors Data to convert
 * @returns {Object} Field errors
 */
export const fieldErrorsBackToFront = (backEndErrors) => {
    let fieldErrorsList = [];
    if (backEndErrors !== null && backEndErrors !== undefined) {
        fieldErrorsList = backEndErrors.map(({ field, messages }) => {
            return {
                field: field,
                messages: messages.join(",")
            };
        });
    }
    return fieldErrorsList;
};



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/misc/dataConversion.ts